import copy from 'copy-to-clipboard';

export const copyExhibitNumberToClipboard = async (textToCopy, href) => {
  if (!textToCopy) {
    return false;
  }
  const copyValue = String(textToCopy);
  const hasHref = typeof href === 'string' && href.length > 0;

  if (
    hasHref &&
    typeof navigator !== 'undefined' &&
    navigator.clipboard?.write &&
    typeof ClipboardItem !== 'undefined'
  ) {
    try {
      const htmlToCopy = `<a href="${href}" style="text-decoration: none; color: inherit;">${copyValue}</a>`;
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/html': new Blob([htmlToCopy], { type: 'text/html' }),
          'text/plain': new Blob([copyValue], { type: 'text/plain' }),
        }),
      ]);
      return true;
    } catch (err) {
      // Fall back to a text-only copy.
    }
  }

  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(copyValue);
      return true;
    } catch (err) {
      // Fall back to a document-based copy approach.
    }
  }

  if (typeof document !== 'undefined') {
    try {
      return copy(copyValue);
    } catch (err) {
      return false;
    }
  }

  return false;
};
